<h1 mat-dialog-title class="text-center">Copy From {{local_data.name}}</h1>
<div mat-dialog-content>
    <div class="entry-forms">
        <div class="tabledesign freightdetailtable" (scroll)="onScroll($event)">
            <!-- <mat-radio-group aria-label="Select an option" [(ngModel)]="documentEntry"> -->
            <table mat-table [dataSource]="this.getListViewDataSourceOnScrollPagination">
                <ng-container matColumnDef="select">
                    <th mat-header-cell *matHeaderCellDef> Select </th>
                    <td mat-cell *matCellDef="let row; let i = index">
                        <!-- <mat-radio-button [value]="row.docEntry"></mat-radio-button> -->
                        <mat-checkbox [(ngModel)]="row.selected" (change)="onSelectionChange(row,$event)">
                        </mat-checkbox>
                    </td>
                </ng-container>
                <ng-container matColumnDef="#">
                    <th mat-header-cell *matHeaderCellDef> # </th>
                    <td mat-cell *matCellDef="let row; let i = index"> {{i+1}} </td>
                </ng-container>
                <ng-container matColumnDef="docNo">
                    <th mat-header-cell *matHeaderCellDef> Document No
                        <i-feather class="t-icon" name="more-vertical" [matMenuTriggerFor]="menu1"></i-feather>
                        <mat-menu #menu1="matMenu" class="filtertrigger" xPosition="after">
                            <app-filter [shortColumn]="'docNum'" [colType]="'numerics'"
                                [labelType]="'Language.DocumentNumberText' | translate" [isActive]="this.active"
                                (FilterColumn)="onClickOfGenericFilterButtonForRangeNumber($event.column, $event.formid, $event.toid,$event.label)"
                                (sortFilter)="this.onClickOfGenericColumnSort('docNum',this.active)"></app-filter>
                        </mat-menu>
                    </th>
                    <td mat-cell *matCellDef="let row">
                        {{row.docNum}}
                    </td>
                </ng-container>
                <ng-container matColumnDef="customerName">
                    <th mat-header-cell *matHeaderCellDef> Bp Name
                        <i-feather class="t-icon" name="more-vertical" [matMenuTriggerFor]="menu1"></i-feather>
                        <mat-menu #menu1="matMenu" class="filtertrigger" xPosition="after">
                            <app-filter [shortColumn]="'cardName'" [colType]="'alphabets'"
                                [labelType]="'Language.CustomerNameText' | translate" [isActive]="this.active"
                                (FilterColumn)="onClickOfGenericFilterButtonForRangeString($event.column, $event.formid, $event.toid,$event.label)"
                                (sortFilter)="this.onClickOfGenericColumnSort('cardName',this.active)"></app-filter>
                        </mat-menu>
                    </th>
                    <td mat-cell *matCellDef="let row">
                        {{row.cardName}}
                    </td> Date
                </ng-container>
                <ng-container matColumnDef="docDate">
                    <th mat-header-cell *matHeaderCellDef> Document Date
                        <i-feather class="t-icon" name="more-vertical" [matMenuTriggerFor]="menu1"></i-feather>
                        <mat-menu #menu1="matMenu" class="filtertrigger" xPosition="after">
                            <app-filter [shortColumn]="'docDate'" [colType]="'DateType'"
                                [labelType]="'Language.DocumentDateText' | translate" [isActive]="this.active"
                                (FilterColumn)="onClickOfGenericFilterButtonForRangeString($event.column, $event.formid, $event.toid,$event.label)"
                                (sortFilter)="this.onClickOfGenericColumnSort('docDate',this.active)"></app-filter>
                        </mat-menu>
                    </th>
                    <td mat-cell *matCellDef="let row">
                        {{row.docDate | date}}
                    </td>
                </ng-container>
                <ng-container matColumnDef="customerCode">
                    <th mat-header-cell *matHeaderCellDef> Bp Code
                        <i-feather class="t-icon" name="more-vertical" [matMenuTriggerFor]="menu1"></i-feather>
                        <mat-menu #menu1="matMenu" class="filtertrigger" xPosition="after">
                            <app-filter [shortColumn]="'cardCode'" [colType]="'alphabets'"
                                [labelType]="'Language.CustomerCodeText' | translate" [isActive]="this.active"
                                (FilterColumn)="onClickOfGenericFilterButtonForRangeString($event.column, $event.formid, $event.toid,$event.label)"
                                (sortFilter)="this.onClickOfGenericColumnSort('cardCode',this.active)"></app-filter>
                        </mat-menu>
                    </th>
                    <td mat-cell *matCellDef="let row">
                        {{row.cardCode}}
                    </td>
                </ng-container>
                <ng-container matColumnDef="docTotal">
                    <th mat-header-cell *matHeaderCellDef> Document Total
                        <i-feather class="t-icon" name="more-vertical" [matMenuTriggerFor]="menu1"></i-feather>
                        <mat-menu #menu1="matMenu" class="filtertrigger" xPosition="after">
                            <app-filter [shortColumn]="'docTotal'" [colType]="'numerics'"
                                [labelType]="'Language.DocumentTotalText' | translate" [isActive]="this.active"
                                (FilterColumn)="onClickOfGenericFilterButtonForRangeNumber($event.column, $event.formid, $event.toid,$event.label)"
                                (sortFilter)="this.onClickOfGenericColumnSort('docTotal',this.active)"></app-filter>
                        </mat-menu>
                    </th>
                    <td mat-cell *matCellDef="let row">
                        {{row.docTotal}}
                    </td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="this.getDisplayedColumnsNamesList;sticky: true"></tr>
                <tr mat-row *matRowDef="let row; columns: this.getDisplayedColumnsNamesList;"></tr>
            </table>
            <!-- </mat-radio-group> -->
        </div>
    </div>
</div>
<div mat-dialog-actions align="end">
    <button mat-raised-button mat-dialog-close>Cancel</button>
    <button mat-raised-button color="primary" mat-dialog-close (click)="onChooseDocument()">
        Choose
    </button>
</div>